export const useDocumentTokenSelectorStore = (documentId: string) => {
  return useDocumentTokenSelector(documentId)();
};
